/* eslint-disable no-continue */
/* eslint-disable no-param-reassign */
import moment from 'moment';
import BaseDataTransformer from '../base-data-transformer/base-data-transformer';

class InvoiceServiceDataTransformer extends BaseDataTransformer {
  transform(data) {
  /*
    maps invoice-service data like this

    {
      values: [
        {start: 1.1.2020, end: 2.1.2020, a: 1, b: 2},
        {start: 2.1.2020, end: 3.1.2020, a: 3, b: 4},
        {start: 3.1.2020, end: 4.1.2020, a: 5, b: 6},
        {title: 'sum', a: 9, b: 12 }
      ]
    }

    into this

    {
      columns: ["Tag", "a", "b"],
      data: [
        { values: [1.1.2020, 1, 2] },
        { values: [2.1.2020, 3, 4] },
        { values: [3.1.2020, 5, 6] },
        { values: ['sum', 9, 12]}
      ]
    }
  */

    if (!data || !data.values || data.values.length < 1) {
      return [];
    }

    const dayIdentifier = 'Tag';
    const { values } = data;

    // fetch all columns
    const columnsSet = { [dayIdentifier]: 1 };
    values.forEach((item) => {
      const propertyNames = Object.keys(item);
      propertyNames.forEach((propertyName) => {
        if (propertyName !== 'start' && propertyName !== 'end' && propertyName !== 'title') {
          columnsSet[propertyName] = 1;
        }
      });
    });

    const columns = Object.keys(columnsSet);
    const dataRows = [];

    // fetch all values
    values.forEach((item) => {
      const dataRow = [];
      columns.forEach((column) => {
        if (column === dayIdentifier) {
          if (item.title) {
            dataRow.push(item.title);
          } else {
            dataRow.push(moment(item.start).format('LL'));
          }
        } else {
          dataRow.push(item[column] ? item[column] / 100 : 0);
        }
      });

      dataRows.push({ values: dataRow });
    });

    return {
      columns,
      data: dataRows,
    };
  }
}

export default InvoiceServiceDataTransformer;
